<div class="form-modal modal-theme">
  <h1 mat-dialog-title>{{'CHANGES'|translate}}</h1>
  <div mat-dialog-content>
    <div class="form-horizontal modal-dialog-custom">
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-bordered display" cellspacing="0">
            <thead>
              <tr>
                <th>
                  <strong>{{ pageStateType }}</strong>
                </th>
                <th>
                  <strong>{{ 'FIELD' | translate }}</strong>
                </th>
                <th>
                  <strong>{{ 'LANGUAGE' | translate }}</strong>
                </th>
                <th>
                  <strong>{{ 'PREVIOUS_VALUE' | translate }}</strong>
                </th>
                <th>
                  <strong>{{ 'NEW_VALUE' | translate }}</strong>
                </th>
                <th>
                  <strong>{{ 'DATE' | translate }}</strong>
                </th>
                <th>
                  <strong>{{ 'USERNAME' | translate }}</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let change of changes">
                <td>{{ change.SectionName | translate }}</td>
                <td>{{ change.FieldLabel | translate }}</td>
                <td class="text-center">
                  <img class="height-20" src="{{'./assets/img/flags/' + (change.LanguageCode ? change.LanguageCode : 'pt_PT') + '.svg'}}"
                    alt="{{ change.LanguageCode }}" />
                </td>
                <td>{{ change.FieldPreviousValue }}</td>
                <td>{{ change.FieldActualValue }}</td>
                <td>{{ change.LastUpdated }}</td>
                <td>{{ change.LastUpdatedByName }}</td>
              </tr>
              <tr *ngIf="changes.length === 0">
                <td class="text-center" colspan="7">{{ 'NO_RESULTS_WERE_FOUND' | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>